import { render } from "./App.vue?vue&type=template&id=261ee2fa"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=261ee2fa&lang=css"

import exportComponent from "/Users/chenli/Documents/buzzbuzz/第九工场/my-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__